export default __webpack_public_path__ + "static/media/wordmark_full-white.577b157b.svg";